<template>
  <v-select
    outlined
    v-model="evolutions"
    :items="evolutionList"
    :menu-props="{ maxHeight: '400', zIndex: 13 }"
    label="Type d'évolution"
    multiple
    item-text="name"
    item-value="id"
  ></v-select>
</template>

<script>
import isEqual from "lodash/isEqual";
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "EvolutionFilter";

/**
 * Either call this component giving an `initialValue` (int[])
 *  and listening on `valueChanged` event,
 * Or call it specifying a `store`
 *  (and eventually `storeGetter`/`storeUpdater`)
 */
export default {
  name: COMPONENT_NAME,
  props: {
    // initialValue: {
    //   type: Array,
    //   validator(values) {
    //     return (
    //       values.length === 0 ||
    //       values.every((value) => typeof value === "number")
    //     );
    //   },
    // },
    store: {
      type: String,
      validator(value) {
        /* List of stores having :
        - getters["<store>/<storeGetter>"]
        - dispatch("<store>/<storeUpdater>", payload)
        */
        return ["webPerf"].includes(value);
      },
    },
    storeGetter: {
      type: String,
      default: "getEvolutions",
    },
    storeUpdater: {
      type: String,
      default: "updateEvolutions",
    },
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const viaStore = computed(() => props.store !== undefined);
    const evolutions = computed({
      get() {
        if (viaStore.value) {
          return store.getters[`${props.store}/${props.storeGetter}`];
        }

        return page.initialUrlValue; // ?? this.initialValue;
      },
      set(e) {
        if (viaStore.value === false) {
          if (!isEqual(e, page.initialUrlValue /*?? this.initialValue*/)) {
            emit("valueChanged", e);
          }

          return;
        }

        store.dispatch(`${props.store}/${props.storeUpdater}`, e);
      },
    });

    // =>  WATCH
    watch(evolutions, (newValue) => {
      if (page.isInitialized) {
        addQueryStringParam({
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: newValue,
          is_multiple: true,
          is_integer: true,
          // is_boolean: false,
        });
      }
    });

    // =>  HOOKS
    onMounted(async () => {
      set(
        page,
        "initialUrlValue",
        await synchronizeFilterWithQueryString({
          dispatcher: viaStore.value
            ? `${props.store}/${props.storeUpdater}`
            : "",
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: evolutions.value,
          is_multiple: true,
          is_integer: true,
          // is_boolean: false,
          // dependsOn: undefined,
        })
      );

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      evolutions,
      evolutionList: [
        { id: -1, name: "Dégradation" },
        { id: 1, name: "Amélioration" },
      ],
    };
  },
};
</script>

<style scoped>
[role="menu"] {
  top: 233px !important;
  right: 0 !important;
}
</style>
